import { useState, useEffect } from "react";
import Joi from "joi-browser";
import Form from "V2.0/components/Form";
import { putTTSSettings } from "../service";
import { newVoiceOptions } from "./voiceOptions";
import { message } from "antd";

function TTSSettings({
  settings,
  syncAssistant,
  assistantId,
  workspaceId,
  onSuccess,
  voicesOptions,
}) {
  const [loading, setLoading] = useState(false);

  const [errorMessage] = useState({});

  const template = [
    {
      name: "voiceId",
      label: "Voice",
      type: "select",
      options: voicesOptions,
    },
  ];

  const buttonInfo = { label: "Save", style: "right-side" };

  const schema = {
    voiceId: Joi.string().label("Voice"),
  };

  const handleSubmit = async (data) => {
    setLoading(true);
    try {
      const response = await putTTSSettings({
        workspaceId,
        assistantId,
        payload: data,
      });
      if (response.status === 200) {
        message.success("Voice Changed");
        setLoading(false);
        syncAssistant((prevAssistant) => {
          return {
            ...prevAssistant,
            ttsSettings: response.data,
          };
        });
        onSuccess();
      }
    } catch (e) {
      message.error(e.response.data?.msg || e.response.data?.message || e.response.data?.error || "Failed to update voice");
      setLoading(false);
      console.error("Error updating TTS settings");
    }
  };

  return (
    <div>
      <Form
        key={JSON.stringify(settings)}
        errorMessage={errorMessage}
        inputField={settings}
        template={template}
        schema={schema}
        onSubmit={handleSubmit}
        loading={loading}
        setLoading={setLoading}
        // getValue ={getInputValue}
        buttonInfo={buttonInfo}
      />
    </div>
  );
}

export { TTSSettings };
